import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/modules/home/services/auth.service';
import { EmailVerifiedSuccessfullyComponent } from '../email-verified-successfully/email-verified-successfully.component';
import { EmailVerifyFailComponent } from '../email-verify-fail/email-verify-fail.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup-successfully',
  templateUrl: './signup-successfully.component.html',
  styleUrls: ['./signup-successfully.component.scss']
})
export class SignupSuccessfullyComponent implements OnInit {

  constructor(
    private _dialogRef: MatDialogRef<SignupSuccessfullyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialog: MatDialog,
    private authService: AuthService,
    public router: Router,
  ) { }

  ngOnInit(): void {
  }

  emailVerifiedSuccessfully() {
    this._dialog.open(EmailVerifiedSuccessfullyComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
    })
  }


  isVeryfy() {

    this.authService.getUer(this.data.id).subscribe(data => {
      console.log(data)
      if (data.lead_verified === true) {
        this._dialog.open(EmailVerifiedSuccessfullyComponent, {
          width: '30%',
          panelClass: 'custom-modal'
        })
      } else {
        this._dialog.open(EmailVerifyFailComponent, {
          width: '30%',
          panelClass: 'custom-modal'
        })
      }
    })

  }


  // logIn(): void {
  //   this._dialog.closeAll(); // close the modal first
  //   this.router.navigate(['/login']); // then redirect to login
  // }

  logIn(): void {
  this._dialog.closeAll(); // Close the modal first

  if (this.data?.type === 'SUPPLIER') {
    this.router.navigate(['/index']); // Navigate to /index for suppliers
  } else {
    this.router.navigate(['/login']); // Navigate to login for others
  }
}



  dialogClose() {
    // this._dialogRef.close();
    this.router.navigate(['/login']);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp");
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }

  // dialogClose(): void {
  //   this._dialog.closeAll(); // close the modal first
  //   this.router.navigate(['/login']); // then redirect to login
  // }
}
